// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const loadQuoteLastModifiedOn = (state: ApplicationState) => {
    return state.store.pages.rfqQuoteDetails.quoteLastModifiedOn;
};

export const loadQuoteDetailsDocuments = (state: ApplicationState) => {
    return state.store.pages.rfqQuoteDetails.rfqDetailsDocuments;
};

export const loadQuoteDetailsUploadMsg = (state: ApplicationState) => {
    return state.store.pages.rfqQuoteDetails.uploadMessage;
};

export const loadQuoteAdditionalInfo = (state: ApplicationState) => {
    return state.store.pages.rfqQuoteDetails.quoteAdditionalInfo;
};
